// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/loteria/loteria.css
// module id = 1033
// module chunks = 0